var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.227,
    height: 14.828,
    viewBox: "0 0 15.227 14.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.307,92.088a2.52,2.52,0,0,1,.465-1.4c1.676-2.054,3.258-4.014,4.841-6.068.465-.56-.093-.84-.465-.56-.559.467-5.4,4.574-6.051,5.228a.558.558,0,0,1-.372.093c-1.024-.373-1.955-.747-2.979-1.12a.86.86,0,0,1-.652-1.027.986.986,0,0,1,.559-.654c1.024-.56,12.475-7,13.5-7.655a.9.9,0,0,1,.838-.093.627.627,0,0,1,.279.747c-.186,2.334-.931,9.9-1.21,12.323-.093.654-.373,1.027-.931.934a.559.559,0,0,1-.372-.093c-1.21-.467-2.514-.934-3.724-1.4-.186-.093-.372-.093-.465.093-2.048,2.054-2.234,2.054-2.514,2.147a.774.774,0,0,1-.931-.56v-.187A1.008,1.008,0,0,0,92.307,92.088Z",
    transform: "translate(-87.076 -78.771)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.144ee1f51e95ac98c14f4771ea273e96.svg";
export { ForwardRef as ReactComponent };